// src/components/TopBar.jsx
import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function TopBar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [signingOut, setSigningOut] = useState(false);

  const handleLogout = async () => {
    try {
      setSigningOut(true);
      await logout();                // sign out
      nav("/", { replace: true });   // go home
    } catch (e) {
      console.error("Logout failed:", e);
      // optional: show a toast
    } finally {
      setSigningOut(false);
    }
  };

  return (
    <div className="w-full border-b border-[#D4FF00]/30 bg-black/70 backdrop-blur sticky top-0 z-50">
      <div className="mx-auto max-w-6xl px-4 py-2 flex items-center justify-between text-sm text-gray-300">
        <div><span>{user.email}</span></div>
        {user ? (
          <div className="text-sm text-gray-300 flex items-center gap-3">
            
            <button
              disabled={signingOut}
              className="px-3 py-1.5 rounded bg-[#D4FF00] text-black font-semibold hover:brightness-90 transition disabled:opacity-60"
              onClick={handleLogout}
            >
              {signingOut ? "Logging out…" : "Logout"}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
